module.exports = __webpack_public_path__ + "static/media/84.646f23eb.jpg";